import { Box, Tooltip } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { format } from 'date-fns';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React, {
  Fragment, useCallback, useMemo, useState,
} from 'react';
import { toast } from 'react-toastify';
import EnhancedTable from 'Shared/EnhancedTable';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import { HeaderData } from 'Components/Client/FinancialBar/FinancialData';
import DownloadIcon from '@mui/icons-material/Download';
import { generateKey } from 'Utils/ulilities';
import ActionsRow from 'Shared/EnhancedTable/ActionsRow';
import useActionsRow from 'Shared/Hooks/useActionsRow';
import { findDepositNameByCode } from 'Shared/constants/order';
import GetAppIcon from '@mui/icons-material/GetApp';
import ErrorOutlinedIcon from '@mui/icons-material/ErrorOutlined';
import { constructAnomalies } from 'Components/ControleOrders/OrdersControl/constants';
import Filters from '../Filters';
import { DEFAULT_VALUES, GratuiteChip } from '../NewOrder/constants';
import {
  defaultMessage, downloadBC, downloadBL, downloadInvoice, getOrders,
} from '../OrdersService';
import { columns, downloadFromLink, mapOrderStatus } from './constants';
import useStyles from './style';
import './style.css';

const InfoHeader = ({ label, value }) => (
  <Box>
    <Typography sx={{ color: '#707070', fontWeight: 600 }}>
      {label}
    </Typography>
    <Typography sx={{ fontWeight: 600 }}>{value}</Typography>
  </Box>

);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    overflowY: 'unset',
  },
}))(MuiDialogContent);

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const {
    children, classes, onClose, ...other
  } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const titles = [
  {
    label: 'RÉFÉRENCE', id: 'product', format: (p) => p?.reference, showGratuiteChip: true,
  },
  {
    label: 'DÉSIGNATION', id: 'product', format: (p) => p?.designation, width: 2,
  },
  { label: 'QUANTITÉ', id: 'quantity' },
  {
    label: 'PRIX UNITAIRE', id: 'prixUnitaire', format: (p) => `${p} Dh`, width: 1.5, struckWhenGratuite: true,
  },
  {
    label: 'REMISE', id: 'remise', format: (p) => `${p}%`, gratuiteColor: true,
  },
  {
    label: 'MONTANT TTC',
    id: 'montantTtc',
    format: (p, row) => (
      <span style={{ color: row?.gratuite ? '#00B894' : '#007BC6' }}>{`${p} Dh`}</span>
    ),
  },
];
/* const getAnomalies = (order) => {
  const quantity = order?.quantityDifference ? ' quantityDifference, ' : '';
  const price = order?.priceAndDiscountDifference ? ' priceAndDiscountDifference, ' : '';
  const payment = order?.paymentModeChange ? ' paymentModeChange, ' : '';
  const expedition = order?.expeditionModeChange
  || order?.expeditionmodeChange ? ' expeditionModeChange.' : '';
  return `${quantity}${price}${payment}${expedition}`;
}; */
export const OrderDetail = ({
  open, setOpen, order, printBC, viewOnly = false,
}) => (
  <Dialog
    onClose={() => setOpen(false)}
    aria-labelledby="customized-dialog-title"
    maxWidth="lg"
    fullWidth
    open={open}
  >
    <DialogTitle id="customized-dialog-title" onClose={() => setOpen(false)}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography sx={{ fontSize: '25px', fontWeight: 600 }}>
              {'Details du documents: '}
              {order?.reference}
              <Tooltip
                placement="top"
                arrow
                sx={{ display: !order?.noAnomaly && 'none' }}
                title={(
                  <Typography
                    sx={{
                      font: 'normal normal 500 19px/30px Montserrat !important',
                      color: '#FFFFFF',
                    }}
                  >
                    {constructAnomalies(order || {})?.map((anomaly) => (
                      <Fragment key={anomaly}>
                        {anomaly}
                        <br />
                      </Fragment>
                    ))}
                  </Typography>
                )}
              >
                <ErrorOutlinedIcon style={{ color: '#E59940' }} />
              </Tooltip>
            </Typography>
            <Typography sx={{ fontWeight: 'bold', color: '#007BC6' }}>
              {`${order?.client?.code || ''} - ${order?.client?.name || ''} - ${order?.client?.city || ''} - ice ${order?.client?.ice || ''}`}
            </Typography>
          </Box>
          {/* <Box sx={{
            background: '#007BC66B', borderRadius: '12px', p: 1.1, mr: '19%',
          }}
          >
            <Typography sx={{ fontWeight: 'bold', fontSize: '30px', color: '#fff' }}>
              {order?.amount}
              <span style={{ fontSize: '15px' }}>TTC</span>
            </Typography>
          </Box> */}
        </Box>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Box sx={{ display: 'flex' }}>
        <Box sx={{ flex: viewOnly ? 1 : 0.9 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2.5 }}>
            <InfoHeader label="DATE" value={order?.date && new Date(order?.date).toLocaleDateString('en-GB')} />
            <InfoHeader label="Piquée par :" value={order?.picker} />
            <InfoHeader label="Facturée par :" value={order?.biller} />
            <InfoHeader
              label="Commercial :"
              value={order?.details?.length > 0
              && `${order.details[0].commercial?.firstName} ${order.details[0].commercial?.lastName}`}
            />
            <InfoHeader label="Nombre de colis :" value={order?.colisage} />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2.5 }}>
            <InfoHeader label="MODE ‘EXPEDITION" value={order?.expedition?.name} />
            <InfoHeader label="MODE DE PAYMENT" value={order?.paymentMode?.name} />
            <InfoHeader label="DEPOT" value={findDepositNameByCode(order?.repoId)} />
            <InfoHeader label="N° EXPEDITION" value={order?.numExpedition} />
            <InfoHeader label="DATE D’IMPRESSION" value={order?.printedDate && format(new Date(order?.printedDate), 'dd/MM/yyyy HH:mm')} />
          </Box>
          <HeaderData columns={titles} sx={{}} />
          {order?.details?.map((detail) => (
            <Box
              sx={{
                borderBottom: '1px solid #38485C1A',
                borderLeft: detail.gratuite ? '5px solid #00B894' : 'none',
                p: 2.1,
                display: 'flex',
              }}
            >
              {titles.map((cel) => (
                <Typography
                  sx={{
                    flex: cel.width || 1,
                    fontWeight: 600,
                    color: '#38485C',
                    ...((cel.gratuiteColor && detail.gratuite) ? { color: '#00B894' } : {}),
                    ...((cel.struckWhenGratuite && detail.gratuite)
                      ? { color: '#C2C2CA', textDecoration: 'line-through' } : {}),
                  }}
                  key={generateKey('data', cel?.id)}
                >
                  {cel.format ? cel.format(detail[cel.id], detail) : detail[cel.id]}
                  {cel.showGratuiteChip && detail.gratuite && (
                    <Box sx={{ mt: 0.5 }}>
                      <GratuiteChip />
                    </Box>
                  )}
                </Typography>
              ))}
            </Box>
          ))}
          <Box sx={{
            mt: 3.5, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',
          }}
          >
            <Typography sx={{ color: '#707070', fontWeight: '600' }}>
              {'NOMBRE DE PRODUITS: '}
              <span style={{ fontSize: '15px', color: '#007BC6' }}>{order?.details?.length}</span>
            </Typography>
            <Typography sx={{
              display: 'flex', flexDirection: 'column', fontWeight: 'bold', fontSize: '30px',
            }}
            >
              <span style={{ fontSize: '15px', color: '#007BC6' }}>TOTAL TTC</span>
              {order?.amount}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: viewOnly && 'none', flex: viewOnly ? 0 : 0.1, ml: 1.8 }}>
          <Box sx={{ display: 'flex', mb: 0.5 }}>
            <IconButton
              onClick={() => printBC(order?.reference, [3, 4].includes(order?.type))}
              sx={{
                background: '#007BC6',
                borderRadius: 1.5,
                padding: 0.5,
                boxShadow: '0px 4px 10px #108CD650',
                color: '#FFF',
              }}
              size="large"
            >
              <DownloadIcon size="small" />
            </IconButton>
            <IconButton
              onClick={() => printBC(order?.reference, [3, 4].includes(order?.type), true)}
              sx={{
                background: '#3B485A',
                borderRadius: 1.5,
                padding: 0.5,
                boxShadow: '0px 4px 10px #108CD629',
                marginLeft: 1,
                color: '#FFF',
              }}
              size="large"
            >
              <VisibilityIcon size="small" />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </DialogContent>
  </Dialog>
);

export const DispalyFileFormLink = ({ link, open, setOpen }) => (
  <Dialog
    onClose={() => setOpen(false)}
    aria-labelledby="customized-dialog-title"
    maxWidth="lg"
    fullWidth
    fullScreen
    sx={{ height: 'auto' }}
    open={open}
  >
    <DialogTitle id="customized-dialog-title" onClose={() => setOpen(false)}>
      Déclaration D`expédition :
    </DialogTitle>
    <DialogContent>
      <embed src={link} width="100%" height="100%" type="application/pdf" />
    </DialogContent>
  </Dialog>
);

const SageOrders = () => {
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(false);
  const [orders, setOrders] = useState({ content: [] });
  const [values, setValues] = useState(
    localStorage.getItem('filters-sage-orders')
      ? JSON.parse(localStorage.getItem('filters-sage-orders') || '{}')
      : DEFAULT_VALUES,
  );
  const [openDetail, setOpenDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openDisplayFile, setOpenDisplayFile] = useState(false);
  const [fileLink, setFileLink] = useState(null);
  const classes = useStyles();
  const {
    onHandleActions, selectedRow, openActions, anchorEl,
  } = useActionsRow();

  const handleInputChange = (prop) => (event, value) => {
    const newValue = {
      ...values,
      [prop]: event instanceof Date ? event : value || event?.target.value,
    };
    localStorage.setItem('filters-sage-orders', JSON.stringify(newValue));
    setValues(newValue);
  };
  const handleRefresh = () => {
    localStorage.setItem('filters-sage-orders', JSON.stringify(DEFAULT_VALUES));
    setValues({ ...DEFAULT_VALUES });
  };
  const getOrderList = useCallback(
    async (sort) => {
      try {
        setLoading(true);
        const data = await getOrders(sort, {
          city: values.city,
          client: values?.client?.code,
          expedition: values?.expedition?.code,
          paymentMode: values?.paymentMode?.code,
          status: values?.status?.id,
          startDate: values.startDate
            ? format(
              values.startDate instanceof Date ? values.startDate : new Date(values.startDate),
              'yyyy-MM-dd',
            )
            : undefined,
          endDate: values.endDate
            ? format(
              values.endDate instanceof Date ? values.endDate : new Date(values.endDate),
              'yyyy-MM-dd',
            )
            : undefined,
          type: values.type?.id,
        });
        setOrders(data);
      } catch (e) {
        const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
        toast.error(statusLabel);
      } finally {
        setLoading(false);
      }
    },
    [setOrders, setLoading, values],
  );

  const getBL = useCallback(
    async (id) => {
      try {
        setLoading(true);
        await downloadBL(id);
      } catch (e) {
        const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
        toast.error(statusLabel);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const getInvoiceCall = useCallback(
    async (id) => {
      try {
        setLoading(true);
        await downloadInvoice(id);
      } catch (e) {
        const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
        toast.error(statusLabel);
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  const getBC = useCallback(
    async (id) => {
      try {
        setLoading(true);
        await downloadBC(id);
        setUpdate((prev) => !prev);
      } catch (e) {
        const { response: { data: { statusLabel = defaultMessage } = {} } = {} } = e;
        toast.error(statusLabel);
      } finally {
        setLoading(false);
      }
    },
    [setUpdate],
  );

  const handleSelectOrder = (order) => {
    setSelectedOrder(order);
    setOpenDetail(true);
  };
  const handleDisplayExpedition = async (link) => {
    setFileLink(link);
    setOpenDisplayFile(true);
  };

  const sageOrders = useMemo(
    () => orders.content.map((order) => ({
      ...order,
      amount: order.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& '),
      client: order.client?.name,
      clientCity: order.client?.city,
      clientIce: order.client?.ice,
      paymentMode: order.paymentMode?.name,
      expedition: order.expedition?.name,
      status: order.status?.status,
      statusClass:
          classes[
            mapOrderStatus[
              order.status && order.status.status ? order.status.status : 'NON_ASSIGNEE'
            ]?.class
          ],
      click: () => handleSelectOrder(order),
      onHandleActions,
    })),
    [orders.content, values, onHandleActions],
  );

  const actions = useMemo(() => (selectedRow ? [
    {
      label: 'Télécharger le bon de livraison',
      icon: <GetAppIcon />,
      onClick: () => getBL(selectedRow.reference),
      disabled: ![3].includes(selectedRow.type),
    },
    {
      label: 'Télécharger la facture',
      icon: <GetAppIcon />,
      onClick: () => getInvoiceCall(selectedRow.reference),
      disabled: ![6, 7].includes(selectedRow.type),
    },
    {
      label: "Télécharger la déclaration d'expédition",
      icon: <GetAppIcon />,
      onClick: downloadFromLink(selectedRow.numExpedition, selectedRow.reference),
      disabled: !(selectedRow.numExpedition && !['LUI MEME BOUSK', 'LUI MEME DERB OMAR', 'CAR']
        .includes(selectedRow.expedition)),
    },
    {
      label: "Aperçu la déclaration d'expédition",
      icon: <VisibilityIcon />,
      onClick: () => handleDisplayExpedition(selectedRow.numExpedition),
      disabled: !(selectedRow.numExpedition && !['LUI MEME BOUSK', 'LUI MEME DERB OMAR', 'CAR']
        .includes(selectedRow.expedition)),
    },
  ] : []), [selectedRow]);
  return (
    <>
      {loading && <GlobalLoader size="100vh" />}
      <Box style={{
        display: 'flex',
        padding: 10,
        alignItems: 'center',
        background: '#E9EBED 0% 0% no-repeat padding-box',
        bordeRradius: '0px 0px 12px 12px',
        opacity: 1,
        marginBottom: 16,
      }}
      >
        <Filters
          values={values}
          handleInputChange={handleInputChange}
          product
          handleRefresh={handleRefresh}
          type
        />
      </Box>
      <OrderDetail
        open={openDetail}
        setOpen={setOpenDetail}
        order={selectedOrder}
        classes={classes}
        printBC={getBC}
        viewOnly
      />
      <DispalyFileFormLink link={fileLink} open={openDisplayFile} setOpen={setOpenDisplayFile} />
      <EnhancedTable
        getData={getOrderList}
        rows={sageOrders}
        headCells={columns}
        update={update}
        count={orders.totalElements}
        rowsPerPageOptions={[10, 15, 20]}
      />
      <ActionsRow
        onClose={onHandleActions}
        isOpen={openActions}
        anchorEl={anchorEl}
        actions={actions}
      />
    </>
  );
};

export default SageOrders;
